import { TransformPlainObject } from './transform.plainObject';

export class ConditionalSplitPlainObject extends TransformPlainObject {
    public disjoint: boolean;
    public conditionExpressions: string[] = [];
}
